export const Types = {
    GET_AREAS: "GET_AREAS",
    GET_MAINTENANCE_TYPE: "GET_MAINTENANCE_TYPE",
    GET_PM_ORDER_DETAIL_BY_ID: "GET_PM_ORDER_DETAIL_BY_ID",
    PM_UPDATE_ORDER: "PM_UPDATE_ORDER",
    PM_CREATE_ORDER: "PM_CREATE_ORDER",
    GET_PM_ORDER_FILES: "GET_PM_ORDER_FILES",
    POST_PM_ADD_FILES: "POST_PM_ADD_FILES",
    PM_UPDATE_SUCCESS: "PM_UPDATE_SUCCESS",
    CREATE_FAILURE: "CREATE_FAILURE",
    RESET_LIST: "RESET_LIST",

    SET_AREAS: "SET_AREAS",
    SET_MAINTENANCE_TYPE: "SET_MAINTENANCE_TYPE",
    SET_PM_ORDER_DETAIL_BY_ID: "SET_PM_ORDER_DETAIL_BY_ID",
    PM_CREATE_ORDER_SUCCESS: "PM_CREATE_ORDER_SUCCESS",
    PM_UPDATE_ORDER_SUCCESS: "PM_UPDATE_ORDER_SUCCESS",
    PM_UPDATE_ORDER_SUCCESS_AFTER: "PM_UPDATE_ORDER_SUCCESS_AFTER",
    SET_PM_ORDER_FILES: "SET_PM_ORDER_FILES",
    POST_PM_ADD_FILES_SUCCESS: "POST_PM_ADD_FILES_SUCCESS",
    PM_CREATE_ORDER_SUCCESS_AFTER: "PM_CREATE_ORDER_SUCCESS_AFTER",

    GET_PM_ORDER_LIST: "GET_PM_ORDER_LIST",
    SET_PM_ORDER_LIST: "SET_PM_ORDER_LIST",
    GET_PM_ORDER_LIST_PAGE: "GET_PM_ORDER_LIST_PAGE",
    SET_PM_ORDER_LIST_PAGE: "SET_PM_ORDER_LIST_PAGE",
    DELETE_PM_ORDER: "DELETE_PM_ORDER",
    DELETE_PM_ORDER_SUCCESS: "DELETE_PM_ORDER_SUCCESS",
    PM_DELETE_ORDER_SUCCESS_AFTER: "PM_DELETE_ORDER_SUCCESS_AFTER",
    SET_PM_ORDER_DETAIL_BY_ID_NULL: "SET_PM_ORDER_DETAIL_BY_ID_NULL",

    GET_PLANNED_CHECKITEMGROUPS_BY_ORDERID: "GET_PLANNED_CHECKITEMGROUPS_BY_ORDERID",
    SET_PLANNED_CHECKITEMGROUPS_BY_ORDERID: "SET_PLANNED_CHECKITEMGROUPS_BY_ORDERID",

    GET_PLANNED_CHECKITEMS_FOR_TASK: "GET_PLANNED_CHECKITEMS_FOR_TASK",
    SET_PLANNED_CHECKITEMS_FOR_TASK: "SET_PLANNED_CHECKITEMS_FOR_TASK",
    PUT_PLANNED_CHECKITEMS_FOR_TASK: "PUT_PLANNED_CHECKITEMS_FOR_TASK",
};

export const getAreaList = () => ({
    type: Types.GET_AREAS,
});

export const setAreaList = (payload) => ({
    type: Types.SET_AREAS,
    payload,
});

export const getMaintenanceType = () => ({
    type: Types.GET_MAINTENANCE_TYPE,
});

export const setMaintenanceType = (payload) => ({
    type: Types.SET_MAINTENANCE_TYPE,
    payload,
});

export const getPMGetOrderDetailById = (payload) => ({
    type: Types.GET_PM_ORDER_DETAIL_BY_ID,
    payload,
});

export const setPMGetOrderDetailById = (payload) => ({
    type: Types.SET_PM_ORDER_DETAIL_BY_ID,
    payload,
});

export const setPMGetOrderDetailByIdNull = () => ({
    type: Types.SET_PM_ORDER_DETAIL_BY_ID_NULL,
});

export const postPMCreateOrder = (payload) => ({
    type: Types.PM_CREATE_ORDER,
    payload,
});

export const postPMCreateOrderSuccess = (payload) => ({
    type: Types.PM_CREATE_ORDER_SUCCESS,
    payload,
});

export const postPMUpdateOrder = (payload) => ({
    type: Types.PM_UPDATE_ORDER,
    payload,
});

export const postPMUpdateOrderSuccess = (payload) => ({
    type: Types.PM_UPDATE_ORDER_SUCCESS,
    payload,
});

export const getPMGetOrderFiles = (payload) => ({
    type: Types.GET_PM_ORDER_FILES,
    payload,
});

export const setPMGetOrderFiles = (payload) => ({
    type: Types.SET_PM_ORDER_FILES,
    payload,
});

export const postPMAddFile = (payload) => ({
    type: Types.POST_PM_ADD_FILES,
    payload,
});

export const postPMAddFileSuccess = (payload) => ({
    type: Types.POST_PM_ADD_FILES_SUCCESS,
    payload,
});

export const pmUpdateOrderSuccess = () => ({
    type: Types.PM_UPDATE_SUCCESS,
});

export const pmCreateOrderAfter = (payload) => ({
    type: Types.PM_CREATE_ORDER_SUCCESS_AFTER,
    payload,
});

export const pmUpdateOrderAfter = () => ({
    type: Types.PM_UPDATE_ORDER_SUCCESS_AFTER,
});

export const getPMOrderList = () => ({
    type: Types.GET_PM_ORDER_LIST,
});

export const setPMOrderList = (payload) => ({
    type: Types.SET_PM_ORDER_LIST,
    payload,
});

export const getPMOrderListPage = (payload) => ({
    type: Types.GET_PM_ORDER_LIST_PAGE,
    payload,
});

export const setPMOrderListPage = (payload) => ({
    type: Types.SET_PM_ORDER_LIST_PAGE,
    payload,
});

export const deletePMOrder = (payload) => ({
    type: Types.DELETE_PM_ORDER,
    payload,
});

export const pmDeleteOrderAfter = (payload) => ({
    type: Types.PM_DELETE_ORDER_SUCCESS_AFTER,
    payload,
});

export const deletePMOrderSuccess = (payload) => ({
    type: Types.DELETE_PM_ORDER_SUCCESS,
    payload,
});

export const getPlannedCheckItemGroupsById = (payload) => ({
    type: Types.GET_PLANNED_CHECKITEMGROUPS_BY_ORDERID,
    payload,
});

export const setPlannedCheckItemGroupsById = (payload) => ({
    type: Types.SET_PLANNED_CHECKITEMGROUPS_BY_ORDERID,
    payload,
});

export const getPlannedCheckItemsForTask = (payload) => ({
    type: Types.GET_PLANNED_CHECKITEMS_FOR_TASK,
    payload,
});

export const setPlannedCheckItemsForTask = (payload) => ({
    type: Types.SET_PLANNED_CHECKITEMS_FOR_TASK,
    payload,
});

export const putPlannedCheckItemsForTask = (payload) => ({
    type: Types.PUT_PLANNED_CHECKITEMS_FOR_TASK,
    payload,
});
